import { Avatar, Tooltip } from '@mui/material'
import LoadingIndicator from '../../common/LoadingIndicator'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import MessageBody from './MessageBody'
import { hasServerId } from '../../utils/chatMessages'

export default function ChatBubble({
  owner,
  sender,
  message,
  firstFromSender,
  lastFromSender,
  handleDeleteMessage,
  readBy,
  users
}) {
  const time = new Date(message.date).toLocaleTimeString('es-UY', {
    hour: '2-digit',
    minute: '2-digit'
  })

  const canDelete = hasServerId(message)

  const handleDeleteClick = () => {
    if (window.confirm('¿Estás seguro que deseas eliminar este mensaje?')) {
      handleDeleteMessage(message)
    }
  }

  return (
    <Tooltip title={readBy} placement={owner ? 'left' : 'right'} arrow>
      <div
        className={`flex gap-2 items-end ${
          owner ? 'flex-row-reverse md:ml-10' : 'flex-row md:mr-10'
        } ${lastFromSender && 'mb-2'}`}
      >
        <Avatar
          src={sender?.picture}
          alt={sender?.name[0]}
          sx={[{ width: 35, height: 35 }, !lastFromSender && { visibility: 'hidden' }]}
        />
        <div className={bubbleClassName(owner, lastFromSender)}>
          {firstFromSender && <p className='text-base'>{sender?.name}</p>}
          <MessageBody message={message} owner={owner} time={time} users={users} />
        </div>
        <div className='h-full flex items-center justify-center'>
          {(message.not_sent || message.pending) && <LoadingIndicator size={12} />}
          {message.failed && (
            <p className='text-xs text-error dark:text-red-400 whitespace-nowrap'>No se envió</p>
          )}
        </div>
        {canDelete && (
          <div
            className='h-full flex items-center justify-center cursor-pointer'
            onClick={handleDeleteClick}
            title='Eliminar mensaje'
          >
            <FontAwesomeIcon icon={faTrash} color='gray' />
          </div>
        )}
      </div>
    </Tooltip>
  )
}

const bubbleClassName = (owner, lastFromSender) => {
  let className = 'flex flex-col gap-1 py-2 px-3 rounded-t-xl'
  if (owner) {
    className += ' rounded-bl-xl bg-light_coral text-white'
  } else {
    className += ' rounded-br-xl bg-white dark:bg-dk-surface text-black dark:text-gray-100'
  }
  if (!lastFromSender) {
    className += ' rounded-b-xl'
  }

  return className
}
